"use strict";

exports.unsafeCompareImpl = function (lt) {
  return function (eq) {
    return function (gt) {
      return function (x) {
        return function (y) {
          return x < y ? lt : x === y ? eq : gt;
        };
      };
    };
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Ord.Unsafe/foreign.js
// module id = 299
// module chunks = 0